import axios from 'axios';

const instance = process.env.NODE_ENV === 'development' ? axios.create({ baseURL: 'https://cakes.co.ke/' })
  : axios.create({ baseURL: 'https://cakes.co.ke/' });
export default instance;
